import React from "react";
import PropTypes from "prop-types";

function ListaOameniCheie({ title, roleLabel, oameniCheie }) {
  return (
    <div className="card">
      <div className="card-header">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="card-header-title">{title}</h4>
          </div>
        </div>
      </div>

      {oameniCheie.map((angajat, idx) => (
        <div key={angajat.id || `${angajat.nume}-${idx}`} className="card-body">
          <div className="row align-items-center">
            <div className="col-auto">
              <span className="avatar avatar-lg">
                <img
                  src="img/avatar-1.jpg"
                  alt={angajat.nume || "avatar"}
                  className="avatar-img rounded-circle"
                />
              </span>
            </div>
            <div className="col ml-n2">
              <h4 className="card-title mb-1">
                <span className="contact-name">{angajat.nume}</span>
              </h4>
              <p className="card-text small">{roleLabel}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

ListaOameniCheie.propTypes = {
  title: PropTypes.string,
  roleLabel: PropTypes.string,
  oameniCheie: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nume: PropTypes.string
    })
  )
};

ListaOameniCheie.defaultProps = {
  title: "",
  roleLabel: "",
  oameniCheie: []
};

export default ListaOameniCheie;
